module.exports = __webpack_public_path__ + "img/print-check-box-un-ticked-disabled.66f4bdca.svg";